import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { getCookie, setLoginCookie, setAppTypeCookie, setSessionCookie, setUserTypeCookie, setPageCookie } from 'mmbclient/Common/CommonFunctions';
import { LOGIN_THROTTLE_TIME, LOGIN_COOKIE_NAME, LOGIN_SESSION_NAME, APP_TYPE_COOKIE_NAME, API_PATH, LOGIN_PATH, USER_TYPE_COOKIE_NAME, PAGE_COOKIE_NAME, MASTERdATA, WALLET } from 'mmbclient/Common/CommonVariable'
import { loadAllMasterData } from 'mmbclient/Common/CommonService';
import Wallet from 'mmbclient/razorPay/Wallet';
import { getClientBalance } from 'mmbclient/Common/CommonRazorPay';


const LoginController = (store) => {
    const masterData = useContext(MASTERdATA)
    const wallet = useContext(WALLET);
    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [userType, setUserType] = useState("US");
    const [showProgressBar, setShowProgressBar] = useState(false);

    const setLoggedIn = () => {
        store.setLogin('in');
    }

    const handleChangeUser = e => {
        setUserType(e.target.value);
    };


    async function checkLogin(event) {
        event.preventDefault();
        if (username.trim() === '') {
            toast.warn('Enter Username!', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } else if (password === '') {
            toast.warn('Enter Password!', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } else {
            setShowProgressBar(true);
            let us = getCookie('__ss_us_');
            let website = us;

            // let href = window.location.href;
            // href = href.split("?");
            // let website = href[1];
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    user: username,
                    password: password,
                    hostname: website,
                    userType: userType,
                })
            };
            let check = false;
            try {
                const path = API_PATH + LOGIN_PATH + "checklogin";
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                // console.log(path);
                // console.log(requestOptions);
                // console.log(data);
                if (data.length === 0) {
                    check = true;
                    setShowProgressBar(false);
                    toast.error('Login Unsuccessful!', {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                if (check === false) {                    
                    const user = [
                        data[0].user_key, data[0].usr_code, data[0].usr_name, data[0].usr_brn_code, data[0].application_type, data[0].page_name
                    ]
                    const sessionId = data[0].sessionId;
                    const userType = data[0].usr_type;
                    const page = user[5];
                    // console.log(user);
                    // let session = window.sessionStorage;
                    // window.sessionStorage.removeItem('__web__');
                    // session.setItem('__usr__', user);
                    // session.setItem('__uid__', true);
                    // window.history.replaceState(null, '', '/');
                    // setLoggedIn();
                    // document.cookie = "__ss_id_=" + user[0].a + ";path=/;max-age=" + 15 * 60;
                    setLoginCookie(LOGIN_COOKIE_NAME, user[0], user[1], user[2], user[3], LOGIN_THROTTLE_TIME);
                    setAppTypeCookie(APP_TYPE_COOKIE_NAME, user[4], LOGIN_THROTTLE_TIME);
                    setSessionCookie(LOGIN_SESSION_NAME, sessionId, LOGIN_THROTTLE_TIME);
                    setUserTypeCookie(USER_TYPE_COOKIE_NAME, userType, LOGIN_THROTTLE_TIME);
                    setPageCookie(PAGE_COOKIE_NAME, page, LOGIN_THROTTLE_TIME);

                    //loading masterdata
                    loadAllMasterData(masterData)
                    // document.cookie = "__ss_id_=" + user[0] + "-" + user[1] + "-" + user[2] + "-" + user[3] + ";path=/;max-age=" + 15 * 60 + "; samesite=lax;";
                    global.ClientName1 = user[2];

                    // setTimeout(() => {
                    //     console.log('click event Listener..............$$$$$$$$$$$$$$$$$$$$$$$$');
                    // }, 7000);
                    getClientBalance(wallet);
                    setLoggedIn();
                    // console.log(document.cookie);
                    // console.log('----------------11111111');
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    return { username, setUserName, password, setPassword, userType, handleChangeUser, showProgressBar, checkLogin };
}

export default LoginController
